export type ImageSize = 'thumb' | 'medium' | 'full';

const FULL_SUFFIXES = ['-full.webp', '-full.jpg'] as const;
const VARIANT_SUFFIX: Record<ImageSize, Record<'webp' | 'jpg', string>> = {
  thumb: { webp: '-thumb.webp', jpg: '-thumb.jpg' },
  medium: { webp: '-medium.webp', jpg: '-medium.jpg' },
  full: { webp: '-full.webp', jpg: '-full.jpg' },
};

function fullSuffixInUrl(url: string): (typeof FULL_SUFFIXES)[number] | null {
  for (const suffix of FULL_SUFFIXES) {
    if (url.includes(suffix)) return suffix;
  }
  return null;
}

export function resolveImageUrl(
  url: string | null | undefined,
  size: ImageSize,
): string | null {
  if (!url) return null;
  if (size === 'full') return url;
  const fullSuffix = fullSuffixInUrl(url);
  if (!fullSuffix) return url;
  const ext = fullSuffix.endsWith('.jpg') ? 'jpg' : 'webp';
  return url.replace(fullSuffix, VARIANT_SUFFIX[size][ext]);
}

export function hasOptimizedVariants(url: string | null | undefined): boolean {
  if (!url) return false;
  return fullSuffixInUrl(url) != null;
}
